import axios from "axios";
import { setLoading } from "./services/loadingService";

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_PRD,
});


api.interceptors.request.use(
  (config) => {

    setLoading(true);

    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    setLoading(false);
    return Promise.reject(error);
  }
);


api.interceptors.response.use(
  (response) => {
    setLoading(false);
    return response;
  },
  (error) => {
    setLoading(false);
    return Promise.reject(error);
  }
);
